export default __webpack_public_path__ + "static/media/home_download_mobile.47b2dc78.png";